<template>
  <section id="journey-section" class="bg-gradient-to-b from-base-50 to-base-100 py-12 md:py-16">
    <!-- Subtle background effects -->
    <div class="absolute inset-0 overflow-hidden pointer-events-none">
      <div
        class="absolute top-1/4 right-1/4 w-56 h-56 bg-gradient-to-r from-secondary/4 to-primary/4 rounded-full blur-3xl"></div>
      <div
        class="absolute bottom-1/3 left-1/3 w-40 h-40 bg-gradient-to-r from-primary/4 to-success/4 rounded-full blur-2xl"></div>
    </div>

    <div class="relative z-10 max-w-5xl mx-auto px-4">
      <!-- Professional header -->
      <div class="text-center mb-12">
        <div class="relative inline-block mb-6">
          <h2 class="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight" id="journey-title">
            <span class="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight text-base-content">
              {{ $t("journeyTimeline.title") }}
            </span>
          </h2>
          <!-- Simple underline -->
          <div
            class="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-gradient-to-r from-secondary to-success rounded-full"></div>
        </div>

        <p class="text-xl text-base-content/80 leading-relaxed max-w-3xl mx-auto">
          {{ $t("journeyTimeline.description") }}
        </p>
      </div>

      <!-- Professional timeline -->
      <div class="relative max-w-4xl mx-auto">
        <ol role="list" class="relative space-y-8" :aria-label="$t('journeyTimeline.ariaLabel')">
          <JourneyStepCard
            v-for="(step, i) in steps"
            :key="i"
            :step="step"
            :index="i"
            :isLast="i === steps.length - 1" />
        </ol>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import JourneyStepCard from "./JourneyStepCard.vue";
import { LucideFileCode, LucidePencil, LucidePhoneCall, LucideRocket, LucideUser } from "lucide-vue-next";
import { useI18n } from "vue-i18n";
import { computed } from "vue";

const { t } = useI18n();

const steps = computed(() => [
  {
    title: t("journeyTimeline.steps.0.title"),
    desc: t("journeyTimeline.steps.0.desc"),
    duration: t("journeyTimeline.steps.0.duration"),
    emotionalBenefit: t("journeyTimeline.steps.0.emotionalBenefit"),
    icon: LucideUser,
  },
  {
    title: t("journeyTimeline.steps.1.title"),
    desc: t("journeyTimeline.steps.1.desc"),
    duration: t("journeyTimeline.steps.1.duration"),
    emotionalBenefit: t("journeyTimeline.steps.1.emotionalBenefit"),
    icon: LucidePhoneCall,
  },
  {
    title: t("journeyTimeline.steps.2.title"),
    desc: t("journeyTimeline.steps.2.desc"),
    duration: t("journeyTimeline.steps.2.duration"),
    emotionalBenefit: t("journeyTimeline.steps.2.emotionalBenefit"),
    icon: LucideFileCode,
  },
  {
    title: t("journeyTimeline.steps.3.title"),
    desc: t("journeyTimeline.steps.3.desc"),
    duration: t("journeyTimeline.steps.3.duration"),
    emotionalBenefit: t("journeyTimeline.steps.3.emotionalBenefit"),
    icon: LucidePencil,
  },
  {
    title: t("journeyTimeline.steps.4.title"),
    desc: t("journeyTimeline.steps.4.desc"),
    duration: t("journeyTimeline.steps.4.duration"),
    emotionalBenefit: t("journeyTimeline.steps.4.emotionalBenefit"),
    icon: LucideRocket,
  },
]);
</script>
